var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.currentRouteName))]),_c('master-data-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }